import { useEffect, useRef } from "react";

export function GoldenParticles({ density = 60 }: { density?: number }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = "";
    for (let i = 0; i < density; i++) {
      const dot = document.createElement("span");
      const size = Math.random() * 2.2 + 0.6;
      dot.style.position = "absolute";
      dot.style.left = Math.random() * 100 + "%";
      dot.style.top = Math.random() * 100 + "%";
      dot.style.width = size + "px";
      dot.style.height = size + "px";
      dot.style.borderRadius = "999px";
      dot.style.background = "rgba(201, 168, 76, 0.85)";
      dot.style.boxShadow = "0 0 6px rgba(201, 168, 76, 0.6)";
      dot.style.animationDelay = Math.random() * 4 + "s";
      dot.className = "twinkle";
      el.appendChild(dot);
    }
  }, [density]);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
    />
  );
}
